import { render } from "./AssignSv.vue?vue&type=template&id=18a5370f"
import script from "./AssignSv.vue?vue&type=script&lang=js"
export * from "./AssignSv.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__